import { ActionCenterViewHandler } from '@/hooks/useActionCenterViewController';

interface OptimizationViewConfig {
  setSelectedItemId: (id: string) => void;
  setIsDialogOpen: (open: boolean) => void;
}

export const OPTIMIZATION_RECOMMENDATIONS_CARD_ID =
  'optimization-recommendations-card';

/**
 * Returns a handler that opens the Action Item dialog for Optimization module
 * whenever the user selects an item from the Action Center slider.
 *
 * The item-text dialog only renders when configured text exists for the item,
 * so we also scroll the Recommendations card into view to guarantee visible
 * feedback for every Explore click.
 */
export function createOptimizationActionCenterHandler({
  setSelectedItemId,
  setIsDialogOpen,
}: OptimizationViewConfig): ActionCenterViewHandler {
  return ({ item, clearSelection }) => {
    setSelectedItemId(String(item.id));
    setIsDialogOpen(true);
    document
      .getElementById(OPTIMIZATION_RECOMMENDATIONS_CARD_ID)
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    clearSelection();
  };
}
